export default "__VITE_ASSET__dsZ7MFeC__"